import type { IPriceImprovementBlotterRequest } from 'apiConnector/blotters/priceImprovementBlotter';
import type {
  ColumnGroupPreferenceState,
  ColumnPreferenceState,
  ServerSideDispatchProps,
  ServerSideOwnProps,
  ServerSideStateProps,
} from 'components/shared/Blotter/Grid/blotter.model';
import { connect } from 'react-redux';
import type { IPriceImprovementBlotterItem } from 'state/blotters/priceImprovement';
import {
  priceImprovementBlotterItemsFetchingFailed,
  priceImprovementBlotterItemsReceived,
  priceImprovementBlotterItemsRequested,
} from 'state/blotters/priceImprovement';
import * as priceImprovementSelector from 'state/blotters/priceImprovement/priceImprovementBlotter.selector';
import {
  priceImprovementBlotterColumnStateChangedThunk,
  priceImprovementBlotterSelectionChangedThunk,
} from 'state/blotters/priceImprovement/priceImprovementBlotter.thunk';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

export type PriceImprovementBlotterServerSideGridProps = ServerSideStateProps<
  IPriceImprovementBlotterRequest,
  IPriceImprovementBlotterItem
> &
  ServerSideDispatchProps<IPriceImprovementBlotterItem, Error> &
  Omit<ServerSideOwnProps<IPriceImprovementBlotterRequest, IPriceImprovementBlotterItem>, 'searchItems' | 'e2e'>;

const mapStateToProps = (
  state: AppState,
): ServerSideStateProps<IPriceImprovementBlotterRequest, IPriceImprovementBlotterItem> => {
  const blotterRequest = priceImprovementSelector.getBlotterRequest(state);

  return {
    columnDefinitions: priceImprovementSelector.getColumnDefinition(state),
    ...priceImprovementSelector.getPreferenceState(state),
    blotterRequest,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch): ServerSideDispatchProps<IPriceImprovementBlotterItem, Error> => ({
  onBlotterColumnStateChanged(
    columnState: readonly ColumnPreferenceState[],
    columnGroupState?: readonly ColumnGroupPreferenceState[],
  ) {
    dispatch(priceImprovementBlotterColumnStateChangedThunk(columnState, columnGroupState));
  },
  onSelectedItemsChanged(items) {
    dispatch(priceImprovementBlotterSelectionChangedThunk(items));
  },
  onItemsReceived({ entries, pageInfo: { totalElements, totalPages } }) {
    dispatch(priceImprovementBlotterItemsReceived(entries, totalElements, totalPages));
  },
  onItemsRequested() {
    dispatch(priceImprovementBlotterItemsRequested());
  },
  onRequestFailed(err: Error) {
    dispatch(priceImprovementBlotterItemsFetchingFailed(err.message));
  },
});

export const connectPriceImprovementBlotterServerSideGrid = connect(mapStateToProps, mapDispatchToProps);
